/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AffiliateApplyRequest } from '../models/AffiliateApplyRequest';
import type { CouponCreateRequest } from '../models/CouponCreateRequest';
import type { CouponRedemptionView } from '../models/CouponRedemptionView';
import type { CouponView } from '../models/CouponView';
import type { SuccessView } from '../models/SuccessView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AffiliateService {
    /**
     * Submit a partner application (/partner page, public)
     * @param requestBody
     * @returns SuccessView Application received
     * @throws ApiError
     */
    public static postAppAffiliatePublicApply(
        requestBody: AffiliateApplyRequest,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/affiliate/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or duplicate application`,
                422: `Captcha verification failed`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * One-click partner approval via the token from the admin email (single-use)
     * @param token
     * @returns SuccessView Partner approved
     * @throws ApiError
     */
    public static getAppAffiliatePublicApprove(
        token: string,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/affiliate/approve/{token}',
            path: {
                'token': token,
            },
            errors: {
                400: `Invalid or already used token`,
            },
        });
    }
    /**
     * Partner profile of the current user
     * @returns any Partner profile
     * @throws ApiError
     */
    public static getAppAffiliateMeGet(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/affiliate/me',
            errors: {
                403: `Current user is not an active partner`,
            },
        });
    }
    /**
     * Partner referral stats: registrations, trials, paying customers, revenue, commission (available / on hold)
     * @param from Y-m-d, filters registrations and payments
     * @param to Y-m-d, filters registrations and payments
     * @returns any Stats
     * @throws ApiError
     */
    public static getAppAffiliateMeStats(
        from?: string,
        to?: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/affiliate/me/stats',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                403: `Current user is not an active partner`,
            },
        });
    }
    /**
     * Partner referral list (emails are masked)
     * @param page
     * @param limit
     * @returns any Referral list
     * @throws ApiError
     */
    public static getAppAffiliateMeReferrals(
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/affiliate/me/referrals',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                403: `Current user is not an active partner`,
            },
        });
    }
    /**
     * Partner coupons (created by the current partner)
     * @returns any Coupon list
     * @throws ApiError
     */
    public static getAppAffiliateMeCouponsList(): CancelablePromise<{
        items?: Array<CouponView>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/affiliate/me/coupons',
            errors: {
                403: `Current user is not an active partner`,
            },
        });
    }
    /**
     * Create a public partner coupon (percent only; discount and activity period are capped — see 400 message)
     * @param requestBody
     * @returns CouponView Coupon created
     * @throws ApiError
     */
    public static postAppAffiliateMeCouponsCreate(
        requestBody: CouponCreateRequest,
    ): CancelablePromise<CouponView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/affiliate/me/coupons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation / cap violation`,
                403: `Current user is not an active partner`,
            },
        });
    }
    /**
     * Deactivate one of the partner's own coupons
     * @param couponId
     * @returns CouponView Coupon deactivated
     * @throws ApiError
     */
    public static postAppAffiliateMeCouponsDeactivate(
        couponId: string,
    ): CancelablePromise<CouponView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/affiliate/me/coupons/{couponId}/deactivate',
            path: {
                'couponId': couponId,
            },
            errors: {
                403: `Not a partner`,
                404: `Coupon not found (or not owned by this partner)`,
            },
        });
    }
    /**
     * Paid redemptions of one of the partner's own coupons (emails are masked)
     * @param couponId
     * @returns any Redemption list
     * @throws ApiError
     */
    public static getAppAffiliateMeCouponsRedemptions(
        couponId: string,
    ): CancelablePromise<{
        items?: Array<CouponRedemptionView>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/affiliate/me/coupons/{couponId}/redemptions',
            path: {
                'couponId': couponId,
            },
            errors: {
                403: `Not a partner`,
                404: `Coupon not found (or not owned by this partner)`,
            },
        });
    }
}
